import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, TextField } from '@mui/material'
import { useContext, useMemo } from 'react'
import { AppContext, DashboardContext } from '../../context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ambientestIcon from '../../assets/img/AppIcon1.svg'
import { ApiSaenvProfileResp, apiSarenvRelevantFields } from '../../types'
import { APPTEXT } from '../../config/text/apptext.config'

interface ModalEnvResponseProps {
    curp?: string,
    data?: ApiSaenvProfileResp | null,
    onClose: VoidFunction
}

export default function ModalEnvResponse({curp, data, onClose }: Readonly<ModalEnvResponseProps>) {
    const dashboardContext = useContext(DashboardContext)
    const appContext = useContext(AppContext)
    const currentPage = useMemo(() => dashboardContext?.navBar.menuSelected, [dashboardContext?.navBar.menuSelected])
    let fieldsToDisplay = apiSarenvRelevantFields.filter(k => !!data?.[k]) || []
    return (
        <Dialog
            open={!!data && !appContext?.appDialogInfo.isOpen}
            scroll={'paper'}
            fullWidth
            className='ambientest-resp'
        >
            <DialogTitle>
                <span className='m-auto d-flex-center'>
                    <FontAwesomeIcon icon="circle-check" style={{ marginRight: '0.5rem' }} />
                    Ambientación generada
                </span>
            </DialogTitle>
            {!!data && <DialogContent className="scroll-app d-flex-column">
                <img src={ambientestIcon} alt="Ambientacion concluida" />
                <DialogContentText id="alert-dialog-description" textAlign={'center'} className='m-auto'>
                    La CURP <b>{curp}</b> ha sido ambientada con el perfil <br/> {currentPage?.label}.
                </DialogContentText>
                {fieldsToDisplay.map(k => <div className='ambientest-resp-field' key={k}>
                    <TextField
                        label={k.toUpperCase()}
                        value={data[k]}
                        size='small'
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            endAdornment: <InputAdornment position="end">
                                <IconButton
                                    onClick={() => {
                                        navigator.clipboard.writeText(data[k] || '').then(() => {
                                            appContext?.openSnackBar(APPTEXT.GENERAL.COPY_SUCCESS)
                                        }).catch(() => {
                                            appContext?.openSnackBar(APPTEXT.GENERAL.COPY_ERROR)
                                        })
                                    }}
                                ><FontAwesomeIcon icon='copy' /> </IconButton>
                            </InputAdornment>
                        }}
                    />
                </div>)}
                {fieldsToDisplay.length > 0 && <DialogContentText id="alert-dialog-description" className='m-auto'>
                    <small>*La información anexa no se podrá recuperar, por lo que se recomienda guardar.</small>
                </DialogContentText>}
            </DialogContent>}
            <DialogActions sx={{ alignContent: 'center' }}>
                <Button
                    className='app-btn-color'
                    variant='contained'
                    disabled={appContext?.loading}
                    onClick={onClose} >
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
